// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Container----Container-module---container---3KHiT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/Container.module.scss
// module id = 49
// module chunks = 22676092666560 178469467687848 221374088121123